"use strict";
/**
 * @author Maxim Seredkin
 */
import angular from "angular";

export default function () {
  return {
    restrict: "A",
    template: require("../../../../../view/table.html"),
    transclude: true,
    scope: {
      selectedItem: "=?myValue",
      items: "=?myItems",
      type: "@myType",
      filters: "=?myFilters",
      ok: "=?myOk",
      isPaging: "=myPagination",
      isSearch: "=mySearching",
      isFilter: "=myFilter",
    },
    controller: [
      "$scope",
      "$log",
      "$utils",
      "$routeParams",
      "$uibModal",
      "StatusService",
      "ProjectService",
      "Notification",
      "$security",
      "ProjectTransactionService",
      function (
        $scope,
        $log,
        $utils,
        $routeParams,
        $modal,
        StatusService,
        ProjectService,
        Notification,
        $security,
        ProjectTransactionService
      ) {
        $scope.getStatusDisplayName = StatusService.getDisplayName;
        $scope.refresh = refresh;
        $scope.dblClick = dblClick;
        $scope.select = select;
        $scope.isSelect = isSelect;
        $scope.getItems = getItems;
        $scope.getValue = $utils.getValue;
        $scope.loading = true;

        // инициализация
        init();

        $security.wait().then(() => {
          // инициализация
          init();
          // получение данных
          refresh();
        });

        let enableDelete = false;
        let enableUpdate = false;

        // region Functions

        function init() {
          if (!$scope.selectedItem) {
            $scope.selectedItem = {};
          }

          $scope.columns = [];

          if (
            $security.isAllowWrite("/projects/requests/finalization", "approve")
          ) {
            $scope.columns = [
              {
                name: "Тип",
                data: "operation",
                type: "func",
                func: ProjectTransactionService.getDisplayOperator,
              },
              {
                name: "Время",
                type: "datetime",
                data: "createDate",
              },
              {
                name: "Код проекта",
                data: "project.code",
              },
              {
                name: "Краткое наименование проекта",
                data: "project.shortName",
              },
              {
                name: "Менеджер проекта",
                data: "createdBy",
                type: "func",
                func: getDisplayUser,
              },
              {
                name: "Отклонена",
                type: "datetime",
                data: "rejectDate",
              },
              {
                name: "Отклонил",
                data: "rejectedBy",
                type: "func",
                func: getDisplayUser,
              },
              {
                name: "Причина",
                data: "comment",
              },
            ];
          } else if (
            $security.isAllowWrite("/projects/requests/finalization", "remove")
          ) {
            $scope.columns = [
              {
                name: "Тип",
                data: "operation",
                type: "func",
                func: ProjectTransactionService.getDisplayOperator,
              },
              {
                name: "Время",
                type: "datetime",
                data: "createDate",
              },
              {
                name: "Код проекта",
                data: "project.code",
              },
              {
                name: "Краткое наименование проекта",
                data: "project.shortName",
              },
              {
                name: "Инициатор",
                data: "project.author.shortName",
              },
              {
                name: "Отклонена",
                type: "datetime",
                data: "rejectDate",
              },
              {
                name: "Отклонил",
                data: "rejectedBy",
                type: "func",
                func: getDisplayUser,
              },
              {
                name: "Причина",
                data: "comment",
              },
            ];
          }

          $scope.searching = {
            isSearch: $scope.isSearch,
            filter: null,
          };

          $scope.pagination = {
            isPaging: $scope.isPaging,
            page: 1,
            size: $scope.isPaging ? 10 : null,
            totalPages: null,
            totalItems: null,
          };

          // тулбокс таблицы
          $scope.toolbox = {
            // кнопки на панели управления
            buttons: {
              // редактирование
              edit: {
                show: () => isSelected(),
                click: (item) => ProjectService.edit(item.project, item.id),
                disabled: () =>
                  $scope.selectedItem == null || $scope.selectedItem.id == null,
              },
              // отказать
              reject: {
                show: () => isSelected() && enableUpdate,
                click: (item) =>
                  ProjectTransactionService.reject(item, (data) => refresh()),
                disabled: () => !enableUpdate,
              },
              // удаление
              remove: {
                show: () => isSelected() && enableDelete,
                click: (item) =>
                  ProjectService.api.deleteTransaction(
                    { transactionId: item.id },
                    null,
                    (data) => $scope.refresh()
                  ),
                disabled: () =>
                  $scope.selectedItem == null ||
                  $scope.selectedItem.id == null ||
                  !enableDelete,
              },

              rework: {
                show: () => false,
              },
            },
          };
        }

        /**
         * Получение всех записей
         * @returns {*}
         */
        function getItems() {
          return $scope.items;
        }

        /**
         * Выбрал ли элемент!
         * @param item проверяемый элемент
         * @returns bool
         */
        function isSelect(item) {
          return equals(getSelected(), item);
        }

        /**
         * Выбрать элемент
         * @param item выбираемый элемент
         */
        function select(item) {
          if (!$scope.isSelect(item)) {
            enableDelete = false;
            enableUpdate = false;
            angular.copy(item, $scope.selectedItem);
            ProjectService.api.enableDeleteTransaction(
              { transactionId: item.id },
              (data) => {
                enableDelete = data._embedded;
              }
            );
            ProjectService.api.enableUpdateTransaction(
              { transactionId: item.id },
              (data) => {
                enableUpdate = data._embedded;
              }
            );
          } else {
            angular.copy({}, $scope.selectedItem);
          }
        }

        /**
         * Двойное нажатие на запись в таблице
         * @param item данные записи
         */
        function dblClick(item) {
          switch ($scope.type) {
            case "table":
              if ($scope.toolbox.buttons.edit) {
                $scope.toolbox.buttons.edit.click(item);
              }
              break;
            case "select":
              $scope.ok();
              break;
          }
        }

        /**
         * Получение фильтров
         * @returns {Array}
         */
        function getFilters() {
          let filters = [];
          if (Array.isArray($scope.filters)) {
            filters = filters.concat($scope.filters);
          }
          filters.push(`'state' EQ 'REWORK'`);
          return filters;
        }

        /**
         * Получение поиска
         * @returns {Array}
         */
        function getSearchs() {
          let searchs = [];
          if ($scope.isSearch) {
            if (
              $scope.searching.filter != null &&
              !($scope.searching.filter.length < 1)
            ) {
              searchs.push(
                "'project.shortName':'" + $scope.searching.filter + "'",
                "'project.name':'" + $scope.searching.filter + "'"
              );
            }
          }
          return searchs;
        }

        /**
         * Выбрана ли запись
         * @returns {boolean}
         */
        function isSelected() {
          return (
            $scope.selectedItem != null &&
            !angular.equals($scope.selectedItem, {})
          );
        }

        /**
         * Проверка элементов на равенство
         * @param i1
         * @param i2
         * @returns {*}
         */
        function equals(i1, i2) {
          return angular.equals(i1, i2);
        }

        /**
         * Получить выбранный элемент
         * @returns {{}|*}
         */
        function getSelected() {
          return $scope.selectedItem;
        }

        /**
         * Обновить данные таблицы
         */
        function refresh() {
          $scope.loading = true;
          ProjectService.api.transactions(
            {
              filters: getFilters(),
              searchs: getSearchs(),
              sorts: [
                "createDate:DESC",
                "project.shortName:ASC",
                "project.name:ASC",
              ],
              page: $scope.pagination.page,
              size: $scope.pagination.size,
            },
            function (data) {
              $scope.items = data._embedded;
              if (isSelected()) {
                if ($scope.items.every((i) => i.id != getSelected().id)) {
                  $scope.selectedItem = {};
                } else {
                  angular.copy(
                    $scope.items.find((i) => i.id == getSelected().id),
                    $scope.selectedItem
                  );
                }
              }
              if ($scope.pagination.isPaging) {
                $scope.pagination.totalPages = data.page.totalPages;
                $scope.pagination.totalItems = data.page.totalElements;
              }
              $scope.loading = false;
            }
          );
        }

        function getDisplayUser(user) {
          if (!user) return "";

          let display = user.username;
          if (!!user.staff && !!user.staff.shortName) {
            display += " (" + user.staff.shortName + ")";
          }
          return display;
        }

        // endregion

        // region Watchers

        $scope.$watch("filters", function () {
          $scope.refresh();
        });

        // endregion
      },
    ],
  };
}
